<template>
  <div class="adpos-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加广告位</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           title="添加广告位"
           @on-ok="createAdpos('adposValidate')"
           :loading="loading">
      <Form :model="adpos"
            ref="adposValidate"
            :rules="adposValidate"
            action="javascript:void(0)">
        <FormItem label="终端"
                  label-position="top">
          <RadioGroup v-model="adpos.is_mobile">
            <Radio label="0">电脑端</Radio>
            <Radio label="1">手机端</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="广告位名称"
                  prop="name">
          <Input v-model="adpos.name"
                 placeholder="输入广告位名称..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal v-model="showEditInfoStatus"
           title="修改广告位"
           @on-ok="updateAdpos('adposValidate')"
           :loading="loading">
      <Form :model="adpos"
            ref="adposValidate"
            :rules="adposValidate"
            action="javascript:void(0)">
        <FormItem label="终端"
                  label-position="top">
          <RadioGroup v-model="adpos.is_mobile">
            <Radio label="0">电脑端</Radio>
            <Radio label="1">手机端</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="广告位名称"
                  prop="name">
          <Input v-model="adpos.name"
                 placeholder="输入广告位名称..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "adpos-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      cateList: [], // 请求分类
      formItem: [],
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "终端",
          key: "mobile",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "name",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      adpos: {
        name: "",
        is_mobile: "1"
      },
      showModalStatus: false,
      showEditInfoStatus: false,
      adposValidate: {
        name: [
          { required: true, message: "广告位名称必须填写", trigger: "blur" }
        ]
      }
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.adpos.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i = 0; i < this.tablelist.length; i++) {
            if (this.tablelist[i].is_mobile.toString() == "1") {
              this.tablelist[i].mobile = "手机端";
            } else {
              this.tablelist[i].mobile = "电脑端";
            }
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.getTableList();
    },
    // 展开添加
    showModel () {
      this.$refs["adposValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createAdpos (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.adpos
            .create({ name: this.adpos.name, is_mobile: this.adpos.is_mobile })
            .then(res => {
              if (res.code == 200) {
                this.showModalStatus = !this.showModalStatus;
                this.getTableList();
              }
            });
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    //展开修改
    showEditInfo: function (index) {
      this.adposid = index;
      this.$refs["adposValidate"].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.adpos.detail({ adpos_id: index }).then(res => {
        if (res.code == 200) {
          this.adpos = res.result;
          this.adpos.is_mobile = this.adpos.is_mobile.toString();
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 修改名称
    updateAdpos: function (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.adpos
            .edit({
              id: this.adpos.id,
              name: this.adpos.name,
              is_mobile: this.adpos.is_mobile
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.showEditInfoStatus = !this.showEditInfoStatus;
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showCreateStatus = !this.showCreateStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.adpos.remove({ adpos_id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>
